<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            [disabled]="data.selectedNodes.length === 0"
            [title]="'IMPORT NODES'">

    <form #mapForm="ngForm" autocomplete="off" class="import-nodes-dialog">
        <ac-input-container label="Nodes to import">
            <ac-select [(acModel)]="data.selectedNodes"
                       class="single-row"
                       [multiple]="true"
                       [allowClear]="true"
                       bindValue="id"
                       bindLabel="name"
                       [items]="data.nodes">
            </ac-select>
        </ac-input-container>
    </form>
</arm-dialog>
